import React from "react";
import '../css/kawaida.css'
import axios from "axios";
import one from '../assets/logo-icon.png'
import two from '../assets/logo-text.png'
import DashHome from "./dashHome";


export default class Kawaida extends React.Component{
    static ax = null;
    constructor(prop) {
        super(prop);

      /*  this.state = {
            message:'',
            answer:''
        }*/

         this.state={
            menu:[{name:<button type="button"   className="uil uil-home active"></button>,pane:<DashHome/>},
                {name: <button type="button" className="uil uil-laptop"></button>,pane: 'two'},
                {name:<button type="button" className="uil uil-envelope "></button>,pane: 'three'},
                {name:<button type="button" onClick={()=>this.logout()} className="uil uil-power"></button>,pane: 'four'}],
            body:<DashHome r={sessionStorage.setItem("uid", sessionStorage.getItem("uid"))}/>,
            currentI:0
        }
        this.displayContent = this.displayContent.bind(this)
    }

    displayContent(i){
        this.setState({
            body:this.state.menu[i].pane,
            currentI:i
        })
    }

  /*  Kawaida.ax = this;
    }
     componentDidMount() {
            Kawaida.loadData();
    }*/

   /* static loadData(){
           axios.get(`http://localhost:8000/api/get/data/`+sessionStorage.getItem("uid")).then((response) => {
       console.table(response.data.data)
             console.log(response.data.data.message)
             this.ax.setState({
                 message: response.data.data.message,
             })
    });

    }*/

    logout(){
         sessionStorage.clear()
         window.open( "/" );
         window.close("kawaida");
    }

    jow(){
        var message = document.getElementById('message').value;
        var sender = sessionStorage.getItem("uid")
        var data = {
            'sender':sender,
            'message':message
        }

        axios.post(`http://localhost:8000/api/post/data`,data).then((response) => {
              Kawaida.loadData();
              this.setState({
                 answer: response.data.answer
             })
           console.log(response)

            const text = response.data.answer
	const utterance = new SpeechSynthesisUtterance(text);
	window.speechSynthesis.speak(utterance);
        });



    }


    render() {
        return (
            /*<div style={{width:'100vw', background:'#222'}}>
              <div className="d-grid gap-2">
        <Button variant="primary" onClick={()=>this.logout()}>
          Log out
        </Button>

        <button>{sessionStorage.getItem("email")}</button>
                  <button>{sessionStorage.getItem("photo")}</button>
                  <input  id={'message'} style={{marginLeft:'20vw', marginRight:'20vw', height:'10vh'}} placeholder={'Ask here...'}/>
                  <center><button style={{width:'10vw', height:'10vh'}} onClick={()=>this.jow()}>{/!*{sessionStorage.getItem("uid")}*!/} ask</button></center>
                  <span style={{background:'#fff', margin:'0 20vw 0 20vw',border:'2px solid #444'}}>
                      <b><i>Last Qn asked: </i></b>
                      {this.state.message}
                  </span>
                  <span style={{background:'#fff', margin:'0 20vw 0 20vw',border:'2px solid #444'}}>{this.state.answer}</span>

      </div>
            </div>*/


            <div className={'main'}>
                <nav className="navbar">
                    <h1 className="navbar-logo">
                        <img className="navbar-logo-icon" src={one}/>
                        <img className="navbar-logo-text" src={two}/>
                    </h1>
                    <nav className="navbar-menu">
                          {this.state.menu.map((d,i)=>{
                                return(
                                    <button onClick={()=>this.displayContent(i)} className={i===this.state.currentI?'active':'non'}>
                                    {d.name}
                                    </button>
                                );
                            })}
                    </nav>
                </nav>

                <div className={'jose_container '}>
                    {this.state.body}
                </div>

            </div>


        );
    }
}